import { Inject, Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { ILinearBetslipMessages } from '../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
    ILinearBetslipMessagesProviderService,
} from '../../base/services/betslip-messages-provider.service';

@Injectable()
export default class LinearBetslipMessageProviderService implements ILinearBetslipMessagesProviderService {
    private messages: ILinearBetslipMessages;

    constructor(
        private sitecore: Sitecore,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) private messageProvider: IBetslipMessagesProviderService,
    ) {}

    getMessages(): ILinearBetslipMessages {
        if (!this.messages) {
            this.initMessages();
        }

        return this.messages;
    }

    private initMessages(): void {
        const betslipMessages = this.messageProvider.getMessages();

        this.messages = { linear: this.sitecore.betslip.linear, betslip: betslipMessages };
    }
}
